import { BusinessUnitList } from '../entities';
import { QueryBusinessUnitPayload } from '../ports/payloads';
import { BusinessUnitRepository } from '../ports/repositories/business-unit.repository';

export class GetListBusinessUnitUsecase {
  constructor(private readonly repo: BusinessUnitRepository) {}

  async run(payload?: QueryBusinessUnitPayload): Promise<BusinessUnitList> {
    const data = await this.repo.getListBU(payload);
    return data;
  }
}
